import { render, staticRenderFns } from "./video-view.vue?vue&type=template&id=47673c16&scoped=true"
import script from "./video-view.vue?vue&type=script&lang=js"
export * from "./video-view.vue?vue&type=script&lang=js"
import style0 from "./video-view.vue?vue&type=style&index=0&id=47673c16&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47673c16",
  null
  
)

export default component.exports